import { AllowedCountries } from './AllowedCountries';
import { AllowedStates } from './AllowedStates';
import { Configuration } from './Configuration';
import { ConfigurationZone } from './ConfigurationZone';

export class Rules {
  /**
   * constructor description
   * @param {Object} rules - An object.
   * @param  {String} rules.code
   * @param  {String} rules.type
   * @param  {Configuration[]} rules.configuration
   * @param  {AllowedCountries?} rules.allowed_countries
   * @param  {AllowedStates?} rules.allowed_states
  */
  constructor({
    code, type, configuration, allowed_countries, allowed_states,
  }) {
    this.code = code;
    this.type = type;
    this.configuration = configuration.map((config) => (this.isWeight() ? new Configuration(config)
      : new ConfigurationZone(config)));
    this.allowed_countries = allowed_countries ? new AllowedCountries(allowed_countries) : null;
    this.allowed_states = allowed_states ? new AllowedStates(allowed_states) : null;
  }

  isWeight() {
    return this.type === 'weight';
  }

  isZone() {
    return this.type === 'zone';
  }

  static createEmpty(type) {
    const isZone = type === 'zone';
    const code = 'Select service';
    const allowed_countries = {
      shipper: {
        filter_type: 'include',
        countries: [],
      },
    };
    const allowed_states = {
      shipper: {
        filter_type: 'include',
        states: [],
      },
    };
    const config = {
      range: [1, 2],
      cost: 1,
      start_date: new Date().toISOString(),
      end_date: new Date().toISOString(),
    };
    const configZone = {
      zone: 1,
      ranges: [config],
    };
    const configuration = isZone ? [configZone] : [config];
    return new Rules({
      code, type, allowed_countries, allowed_states, configuration,
    });
  }

  addRange() {
    if (!this.isWeight()) return;
    const newConfig = Configuration.createEmpty();
    this.configuration.push(newConfig);
  }

  addZone() {
    if (!this.isZone()) return;
    const newConfig = ConfigurationZone.createEmpty();
    this.configuration.push(newConfig);
  }
}
